import { useMemo } from "react";
import { boronClient } from "../../../../api";
import { UnprocessableEntityError } from "../../../../errors";
import { useBoronMutation } from "../../../../hooks/http/useBoronMutation";
import { paths } from "../../../../lib/api/v1";
import { useOperatorsCacheUpdater } from "../../useFetchOperators";

type InviteOperatorResponse =
  paths["/api/v1/sections/{section_id}/operators/invitation"]["post"]["responses"]["200"]["content"]["application/json"];

type InviteOperatorVariables = {
  sectionId: string;
  email: string;
};

export const useInviteOperator = () => {
  const { addInvitingOperator } = useOperatorsCacheUpdater();

  const mutation = useBoronMutation<
    InviteOperatorResponse,
    InviteOperatorVariables
  >(
    async ({ sectionId, email }) =>
      await boronClient.POST(
        "/api/v1/sections/{section_id}/operators/invitation",
        {
          params: {
            path: {
              section_id: sectionId,
            },
          },
          body: {
            operator: {
              email,
            },
          },
        },
      ),
    {
      onSuccess: (data, { sectionId }) => {
        addInvitingOperator(sectionId, data.invitingOperator);
      },
    },
  );

  const apiErrors = useMemo(() => {
    if (mutation.error instanceof UnprocessableEntityError) {
      return mutation.error.originalErrors;
    }
    return null;
  }, [mutation.error]);

  return {
    ...mutation,
    apiErrors,
  };
};
